<template>
  <div v-if="isDataLoaded">
    <p class="card-title">
      {{ getString('module.dashboard.stats.usage') }}
    </p>
    <div class="card-block" :class="{'has-redirect':hasRedirect}" @click="redirect()">
      <line-chart
        v-show="dataReady"
        :chartData="data"
        :options="options"
        :height="200"
        :ref="component"
      />
      <!-- Legends -->
      <div
        v-for="(legend, index) in data.legends"
        :key="index"
        class="legend q-ml-md q-mt-md q-mb-sm"
        :class="{
          'text-hidden': data.datasets[index].hidden,
        }"
        @click="toggleData(index)"
      >
        <div :class="legend.color"></div>
        <span>{{ legend.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import statistics from './statisticsComponent';

export default {
  mixins: [statistics],
  data() {
    return {
      component: 'usages',
      data: {
        labels: [],
        datasets: [
          this.initDataset(this.getColor('blue')),
          this.initDataset(this.getColor('red')),
          this.initDataset(this.getColor('purple')),
          this.initDataset(this.getColor('yellow')),
        ],
        legends: [{
          color: 'blue',
          label: this.getString('module.dashboard.stats.dealer-locator'),
        },
        {
          color: 'red',
          label: this.getString('module.dashboard.stats.dealer-locator-requests'),
        },
        {
          color: 'purple',
          label: this.getString('module.dashboard.stats.airconfigurator'),
        },
        {
          color: 'yellow',
          label: this.getString('module.dashboard.stats.heatpump-selector'),
        },
        ],
      },
      options: {
        scales: this.scaleOptions,
        elements: {
          point: {
            radius: 2,
          },
          line: {
            borderColor: this.getColor('blue'),
          },
        },
        legend: {
          display: false,
        },
      },
    };
  },
  methods: {
    handleData() {
      const stats = this.statisticData;
      this.data.datasets[0].data = stats.map(x => x.dealerLocatorUsage);
      this.data.datasets[1].data = stats.map(x => x.dealerLocatorRequests);
      this.data.datasets[2].data = stats.map(x => x.airconfiguratorUsage);
      this.data.datasets[3].data = stats.map(x => x.heatpumpSelectorUsage);
      this.data.labels = stats.map(x => this.formatDate(x.date, this.labelDateFormat));
      this.dataReady = true;
    },
  },
};
</script>

<style lang="stylus" scoped src="@/styles/components/statistics.styl"></style>
